import { render, staticRenderFns } from "./WorkSelector.vue?vue&type=template&id=4107ede5&scoped=true"
import script from "./WorkSelector.vue?vue&type=script&lang=js"
export * from "./WorkSelector.vue?vue&type=script&lang=js"
import style0 from "./WorkSelector.vue?vue&type=style&index=0&id=4107ede5&prod&lang=scss"
import style1 from "./WorkSelector.vue?vue&type=style&index=1&id=4107ede5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4107ede5",
  null
  
)

export default component.exports